import * as React from "react";

function SvgTapstream(props, ref) {
  return (
    <svg
      viewBox="0 0 133.3 98.4"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <radialGradient
        id="tapstream_svg__a"
        cx={345.688}
        cy={111.696}
        r={353.618}
        gradientTransform="matrix(1 0 0 -1 0 100)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#666" />
        <stop offset={1} stopColor="#333" />
      </radialGradient>
      <path
        d="M44.2 92c0 2.8-2.2 5-5 5H29c-2.8 0-5-2.2-5-5V23.2c0-2.8-2.2-5-5-5H5c-2.7 0-5-2.3-5-5V6.3c0-2.8 2.3-5 5-5h58.2c2.8 0 5 2.2 5 5v6.9c0 2.8-2.3 5-5 5H49.3c-2.8 0-5 2.2-5 5V92z"
        fill="url(#tapstream_svg__a)"
      />
      <radialGradient
        id="tapstream_svg__b"
        cx={195.688}
        cy={111.696}
        r={353.618}
        gradientTransform="matrix(1 0 0 -1 0 100)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#666" />
        <stop offset={1} stopColor="#333" />
      </radialGradient>
      <path
        d="M129.9 84c-7.5 16.9-34.3 16.3-48.8 11.5-2.7-.9-6.5-2.1-6.5-8.4v-6.3c0-2.9 2.4-5.8 6.1-4.3 9.5 3.9 27.3 9.5 31.7-1 5.9-14.3-20.3-20.2-28.9-29.1-8-8.3-9.2-17.7-6.6-28.2 3.2-12.5 19.2-23 44.3-15.9 4 1.3 5.3 2.4 5.3 8.5v4.9c0 3.3-3.3 5.3-6.9 3.9-7.3-2.8-18.2-5.4-22.5 1.7-4.6 7.7.5 14.8 13.4 20.4 16.7 7.3 29 20.6 19.4 42.3z"
        fill="url(#tapstream_svg__b)"
      />
      <path
        d="M44.2 92c0 2.8-2.2 5-5 5H29c-2.8 0-5-2.2-5-5V23.2c0-2.8-2.2-5-5-5H5c-2.7 0-5-2.3-5-5V6.3c0-2.8 2.3-5 5-5h58.2c2.8 0 5 2.3 5 5v6.9c0 2.8-2.3 5-5 5H49.3c-2.8 0-5 2.2-5 5V92zm85.7-8c-7.5 16.9-34.3 16.3-48.8 11.5-2.7-.9-6.5-2.1-6.5-8.4v-6.3c0-2.9 2.4-5.8 6.1-4.3 9.5 3.9 27.3 9.5 31.7-1 5.9-14.3-20.3-20.1-28.9-29.1-8-8.3-9.2-17.7-6.6-28.2 3.2-12.5 19.2-23 44.3-15.9 4 1.3 5.3 2.4 5.3 8.5v4.9c0 3.3-3.3 5.3-6.9 3.9-7.3-2.8-18.2-5.4-22.5 1.7-4.6 7.7.5 14.8 13.4 20.4 16.7 7.3 29 20.6 19.4 42.3z"
        opacity={0.3}
      />
    </svg>
  );
}

export default React.forwardRef(SvgTapstream);
